
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationRenameHeadline: {
    id: "ConfigurationRename.headline",
    defaultMessage: "How would you like to call your configuration?",
  }, 
});

export default MESSAGES;